var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dash',{attrs:{"icon":"fa fa-users","titulo":"TOTAL DE ACESSOS","qtd":_vm.qtd,"loading":_vm.loading,"color":"#A3E0FC"}})}
var staticRenderFns = []

export { render, staticRenderFns }